import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=1bcb16d5&"
import script from "./Terms.vue?vue&type=script&lang=ts&"
export * from "./Terms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports